import styled from "styled-components";
import { Typography } from "@ann/web-components";

export const EmptyStateWrapper = styled.div`
  display: flex;
  flex: 1;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  padding: 24px 0 32px;
`;

export const EmptyStateContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  min-height: 280px;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

export const CardWrapper = styled.div`
  width: 100%;
  text-align: center;
`;

export const CTAWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const CTAButton = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  max-width: 240px;
  margin: 0 auto;
`;

export const DescriptionText = styled(Typography)`
  color: ${(props) => props.theme.colors.greyThree || "#4B5563"};
`;

